function welcomeReducer(state = true, action) {
  return action.type === "CLOSE_WELCOME_MODAL" ? false : state;
}

export default welcomeReducer;
